import React, { useState, useEffect } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Button, IconButton, Switch, Tooltip, Typography, Skeleton } from '@mui/material'; // Ensure Skeleton is imported
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const DynamicTable = ({ data, onEditClick, onViewClick, onPasswordClick, loading }) => {
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const handleActiveChange = (row) => {
    const updatedData = tableData.map(item =>
      item === row.original ? { ...item, ACTIVE: item.ACTIVE === '1' ? '0' : '1' } : item
    );
    setTableData(updatedData);
  };
  // const tableStyle = {
  //   '& .MuiTableHead-root .MuiTableCell-root': {
  //     width: calculateColumnWidth(Object.keys(tableData[0]).length), // Adjust header cell width dynamically
  //   },
  //   '& .MuiTableCell-root': {
  //     width: calculateColumnWidth(Object.keys(tableData[0]).length), // Adjust body cell width dynamically
  //   },
  // };
  
  const columns = React.useMemo(() => {
    if (tableData.length === 0) return [];
    //const columnCount = Object.keys(tableData[0]).length;
    const hasPasswordColumn = Object.keys(tableData[0]).includes('PASSWORD');
    return [
      {
        accessorKey: 'actions',
        header: 'Actions',
        size: 50,
        wordWrap: 'break-word',		
        Cell: ({ row }) => (
          <Box sx={{ display: 'flex' }}>
            <IconButton onClick={() => {
              setEditingRow(row);
              onEditClick(row.original);
            }}>
              <EditIcon />
            </IconButton>
            <Tooltip title="View">
              <IconButton onClick={() => {
                onViewClick(row.original);
                handleView(row.original);
              }}>
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            {hasPasswordColumn && (
              <Tooltip title="Change Password">
                <IconButton onClick={() => {
                  onPasswordClick(row.original);
                  handleChangePassword(row.original);
                }}>
                  <LockOpenIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ),
        sticky: 'left',
      },
      ...Object.keys(tableData[0]).map((header) => ({
        
        accessorKey: header,
        header: <span >{header.replace(/_/g, ' ')}</span>, 
        size: 50,
       
        // Replace underscores with spaces
        Cell: ({ row }) => {
          if (header === 'ACTIVE') {
            return (
              <Switch
                checked={row.original[header] === '1'}
                onChange={() => handleActiveChange(row)}
                name={`active-switch-${row.id}`}
                color="primary"
              />
            );
          }
          return row.original[header];
        },
        
      })),
      
    ];
  }, [tableData]);

 
  const table = useMaterialReactTable({
    
    columns,
    data: tableData,
    initialState: {
      density: 'compact',
      pagination: { pageSize: 100, pageIndex: 0, enableDensityToggle: true },
      
      
    },
    enableStickyHeader: true,
    enableStickyFooter: true,
    enablePagination: true,
    muiTableContainerProps: { sx: { maxHeight: '400px' } },
    muiTableBodyCellProps: {
      sx: (theme) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[900]
            : theme.palette.grey[50],
      }),
    },
    
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          setEditingRow(null);
          onEditClick(null);
        }}
        startIcon={<AddIcon />}
      >
        Add New
      </Button>
    ),
    
  });

  const [viewingRow, setViewingRow] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [passwordRow, setPasswordRow] = useState(null);
  const [creatingRow, setCreatingRow] = useState(false);
  const [newRowData, setNewRowData] = useState({});


  const handleView = (rowData) => {
    setViewingRow(rowData);
  };

  const handleClose = () => {
    setViewingRow(null);
    setEditingRow(null);
    setCreatingRow(false);
    setNewRowData({});
  };

  const handleSaveNewRow = () => {
    console.log('New Row Data:', newRowData);
    handleClose();
  };

  const handleChangePassword = (rowData) => {
    // Logic to handle password change
  };

  return (
    <div>
      {loading ? ( // Ensure loading prop is correctly set
        <Box display="flex" justifyContent="center" alignItems="center" height={400}>
          <Skeleton variant="rectangular" width={300} height={100} animation="wave" />
          <Typography variant="body1" ml={2}>Loading...</Typography>
        </Box>
      ) : (
        <Box position="relative">
          <MaterialReactTable  enableStickyHeader style={{  density: 'compact' }} table={table} />
        </Box>
      )}
    </div>
  );
};

export default DynamicTable;
